module.exports = __webpack_public_path__ + "static/media/lakes_of_northville.16e1bbc3.pdf";